import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {DLPageTypeEnum} from '../../../../enums/DataLayerEnums';
import {CareService} from '../../../../types/CareService';
import {CareproviderContactInfo} from '../../../../types/CareproviderContactInfo';
import {CareproviderUnitType} from '../../../../types/CareproviderUnitType';
import {ToolsService} from '../../../../services/tools.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-care-service-info-top',
  templateUrl: './care-service-info-top.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'relative w-screen ml-[-50vw] left-1/2 xl:w-full xl:ml-0 xl:left-0 care-service-info-top block xl:rounded-lg border border-duck-blue-9 bg-duck-blue-10 p-3 lg:p-4 flex justify-between items-center gap-3 lg:p-4',
  },
})
export class CareServiceInfoTopComponent {
  public careService = input<CareService>(null);
  public logoUrl = input<string>(null);
  public careProviderUnitName = input<string>(null);
  public careProviderUnitUrl = input<string[]>(null);
  public careProviderContactInfo = input<CareproviderContactInfo>(null);
  public mainCaregiverUnitType = input<CareproviderUnitType>(null);
  protected displayBookingBtn = computed(
    () =>
      this.careService() &&
      !this.tools.isNil(this.careService().bookingConfigurationData) &&
      this.careService().bookingConfigurationData.length > 0,
  );
  protected readonly dLPageTypeEnum = DLPageTypeEnum;

  constructor(
    private tools: ToolsService,
    private router: Router,
  ) {}

  public openCpruPage(): void {
    this.router.navigate(this.careProviderUnitUrl());
  }
}
